module.exports = __webpack_public_path__ + "assets/img/four-bg.29a1650f.png";